import React from 'react';

import MobileOnly from 'components/consumer/MobileOnly';
import MobileModal from 'components/consumer/MobileModal';
import CtaButton from 'components/essentials/Cta/CtaButton';
import QuickShipFilter from 'components/essentials/ConsumerFilters/components/QuickShipFilter';
import WidthRangeFilter from 'components/consumer/consumer-search/advanced-search-next/components/WidthRangeFilter';
import useAdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/useAdvancedSearchContext';

import MobileProductFilters from './MobileProductFilters';
import MobileProductListingColorFilter from './MobileProductListingColorFilter';
import ProductClearAllFiltersButton from './ProductClearAllFiltersButton';

const MobileProductFiltersModal = ({
  isOpen,
  onClose,
  productsCount,
  items,
  refine,
  canClear,
  clearRefinement,
}) => {
  const activeFilterCount = items.filter(item => item.isRefined).length;

  const {
    isReadyToShipActive,
    handleToggleReadyToShip,
  } = useAdvancedSearchContext();

  return (
    <MobileOnly>
      <div className="md:hidden">
        <MobileModal
          enableHashHistory={false}
          headerRight={
            <ProductClearAllFiltersButton
              canClear={canClear}
              clearRefinement={clearRefinement}
            />
          }
          isFullHeight
          isOpen={isOpen}
          onClose={onClose}
          stickyFooter={
            <CtaButton block onClick={onClose}>
              Done ({productsCount || 0} result{productsCount === 1 ? '' : 's'})
            </CtaButton>
          }
          title={
            activeFilterCount > 0 ? `Filters (${activeFilterCount})` : 'Filters'
          }
        >
          <div className="mb-4">
            <QuickShipFilter
              isChecked={isReadyToShipActive}
              onChange={handleToggleReadyToShip}
              minHeight={false}
              withLocation
              showLabelOnMobile
            />
          </div>
          <div className="mb-4">
            <WidthRangeFilter showTitle />
          </div>
          <div className="mb-4">
            <MobileProductListingColorFilter />
          </div>
          <MobileProductFilters items={items} refine={refine} />
        </MobileModal>
      </div>
    </MobileOnly>
  );
};

export default MobileProductFiltersModal;
